import React from "react";
import FileInput from "../fileInput/FileInput";
import { useTranslator } from "context/translator";
import FormError from "components/formError/FormError";

const DocumentUtilityBillForm = ({ data, onChange, form }) => {
  const { translate } = useTranslator();

  const update = (field, value) => {
    onChange({ ...data, [field]: value });
  };

  const handleToggleStatus = () => {
    onChange({ ...data, status: !data.status });
  };

  return (
    <div className="border rounded-xl p-4 space-y-4 bg-white dark:bg-gray-900 shadow">
      <div className="flex justify-between items-center">
        <h3 className="font-semibold text-lg dark:text-white">
          {translate("utility-bill")}
        </h3>

        {data?._id && (
          <button
            type="button"
            onClick={handleToggleStatus}
            className={`text-sm ${
              data.status ? "text-red-600" : "text-green-600"
            }`}
          >
            {data.status
              ? translate("deactivate-card")
              : translate("activate-card")}
          </button>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* First Name */}
        <div>
          <label className="label">{translate("first-name")}</label>
          <input
            type="text"
            value={data.firstName || ""}
            onChange={(e) => update("firstName", e.target.value)}
            className="input"
            required
          />
          <FormError form={form} name="firstName" />
        </div>

        {/* Last Name */}
        <div>
          <label className="label">{translate("last-name")}</label>
          <input
            type="text"
            value={data.lastName || ""}
            onChange={(e) => update("lastName", e.target.value)}
            className="input"
            required
          />
          <FormError form={form} name="lastName" />
        </div>

        {/* Service Provider */}
        <div>
          <label className="label">{translate("service-provider")}</label>
          <input
            type="text"
            value={data.provider || ""}
            onChange={(e) => update("provider", e.target.value)}
            className="input"
            required
          />
          <FormError form={form} name="provider" />
        </div>

        {/* Account / Contract Number */}
        <div>
          <label className="label">{translate("account-number")}</label>
          <input
            type="text"
            value={data.accountNumber || ""}
            onChange={(e) => update("accountNumber", e.target.value)}
            className="input"
            required
          />
          <FormError form={form} name="accountNumber" />
        </div>

        {/* Issue Date */}
        <div>
          <label className="label">{translate("issue-date")}</label>
          <input
            type="date"
            value={data.issueDate || ""}
            onChange={(e) => update("issueDate", e.target.value)}
            className="input"
            required
          />
          <FormError form={form} name="issueDate" />
        </div>

        {/* Address */}
        <div className="md:col-span-2">
          <label className="label">{translate("address")}</label>
          <textarea
            value={data.address || ""}
            onChange={(e) => update("address", e.target.value)}
            className="input"
            required
          />
          <FormError form={form} name="address" />
        </div>
      </div>

      {/* Files */}
      <FileInput
        label={translate("utility-bill-files")}
        files={data.files || []}
        onAdd={(newFiles) =>
          update("files", [...(data.files || []), ...newFiles])
        }
        onRemove={(idx) =>
          update(
            "files",
            data.files.filter((_, i) => i !== idx),
          )
        }
      />
    </div>
  );
};

export default DocumentUtilityBillForm;
